module.exports = __webpack_public_path__ + "img/warehouse-High.95be0ffd.svg";